export default "__VITE_ASSET__CH5rSJjP__"